module.exports = __webpack_public_path__ + "static/img/top-concept.228ca0e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top-concept.svg
// module id = wkMq
// module chunks = 0